<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        title="电站列表"
        :data="tableData"
        :columns="tableColumns"
        :selectable="true"
        :rowSelectable="() => true"
        :selectOnIndeterminate="false"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())"
        @selection-change="selectionChange">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button v-rbac="'operation:price:rake:config'" type="plain" @click="handleBatchSet">
              批量设置
            </ykc-button>
            <ykc-button
              v-rbac="'operation:price:rake:export'"
              type="plain"
              @click="handleExportData">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageIndex"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>
    </div>
    <ykc-drawer
      :show.sync="showDrawer"
      title="抽成费用策略"
      :on-close="onAddDrawerClose"
      :before-cancel="onAddDrawerCancel">
      <template #footer>
        <div class="drawer-button-wrap">
          <template v-for="(btn, i) in drawerButtons">
            <ykc-button
              style="margin-left: 8px"
              :type="btn.type"
              v-if="btn.enabled()"
              :key="i"
              @click="btn.handler">
              {{ btn.label }}
            </ykc-button>
          </template>
        </div>
      </template>
      <div class="drawer-main-body" v-if="showDrawer">
        <AddOrEdit
          :selectedRows="selectedRows"
          :currentRow="currentRow"
          :operateType="operateType"
          ref="addOrEdit"></AddOrEdit>
      </div>
    </ykc-drawer>
  </scroll-layout>
</template>

<script>
  import AddOrEdit from './AddOrEdit.vue';
  import { offlineExport, code } from '@/utils';
  import YkcDialog from '@/components/ykc-ui/dialog';
  import { commissionStrategy, directPage } from '@/service/apis';

  export default {
    name: 'RoyaltyStrategyList',
    components: {
      AddOrEdit,
    },
    data() {
      return {
        operateType: '',
        currentRow: null,
        selectedRows: [],
        showDrawer: false,
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => true,
            handler: () => {
              YkcDialog({
                dialogType: 'feedback',
                showTitle: false,
                showFooter: true,
                desc: '取消后操作将不被保存，确认是否取消？',
                onCancel: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                },
                onConfirm: dialogDone => {
                  dialogDone(); // 隐藏弹窗
                  this.showDrawer = false; // 隐藏抽屉
                },
              });
            },
          },
          {
            label: '保存',
            enabled: () => true,
            handler: () => {
              this.$refs.addOrEdit &&
                this.$refs.addOrEdit.submitForm(() => {
                  this.showDrawer = false;
                  this.searchTableList();
                });
            },
          },
        ],
        tableData: [],

        tableOperateButtons: [
          {
            enabled: () => code('operation:price:rake:edit'),
            render: (h, button, { row }) => {
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.doEdit(row);
                  }}>
                  编辑
                </ykc-button>
              );
            },
          },
        ],
        tableColumns: [
          { label: '电站编码', prop: 'stationId' },
          { label: '电站名称', prop: 'stationName' },
          { label: '归属商家', prop: 'stationOperatorName' },
          {
            label: '电费抽成',
            prop: 'powerRate',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { powerRateType, powerRate } }) => {
                const powerRateTypeName = {
                  1: `度数：${powerRate}元/度`,
                  2: `折扣：金额${powerRate}%`,
                }[powerRateType];
                return powerRateTypeName || '————';
              },
            },
          },
          {
            label: '服务费抽成',
            prop: 'serviceRate',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { serviceRateType, serviceRate } }) => {
                const serviceRateTypeName = {
                  1: `度数：${serviceRate}元/度`,
                  2: `折扣：金额${serviceRate}%`,
                }[serviceRateType];
                return serviceRateTypeName || '————';
              },
            },
          },
          {
            label: '状态',
            prop: 'status',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row: { status } }) => {
                const statusText = {
                  0: '未配置',
                  1: '已配置',
                }[status];
                return statusText || '一';
              },
            },
          },
          { label: '修改人', prop: 'modifiedAccount' },
          { label: '修改时间', prop: 'modifiedTime' },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          stationName: '',
          stationOperatorId: '',
          status: '',
        },
        OperatorListData: [], // 归属商户
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'stationName',
            label: '电站名称',
            placeholder: '请输入电站名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'stationOperatorId',
            label: '归属商家',
            placeholder: '请输入归属商家',
            data: this.OperatorListData,
            remote: true,
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '状态',
            placeholder: '请选择状态',
            data: [
              { id: '', name: '全部' },
              { id: '0', name: '未配置' },
              { id: '1', name: '已配置' },
            ],
          },
        ];
      },
    },
    created() {
      this.searchTableList();
      this.requestOperatorList();
    },
    methods: {
      requestOperatorList() {
        directPage.userOperatorList({ keyword: '' }).then(res => {
          // eslint-disable-next-line no-unused-vars
          this.OperatorListData = (res || []).map(({ operatorId, name }) => ({
            name,
            id: String(operatorId),
          }));
        });
      },
      handleExportData() {
        offlineExport(
          {
            downloadType: 'station_price_export',
            jsonNode: {
              downloadKey: 'commission_price_list',
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      doEdit(row) {
        console.log('row', row);
        this.operateType = 'single';
        this.currentRow = row;
        this.showDrawer = true;
      },
      searchTableList() {
        const data = {
          ...this.searchParams,
          size: this.pageInfo.pageSize,
          current: this.pageInfo.pageIndex,
        };
        commissionStrategy.queryForPage(data).then(res => {
          this.tableData = res.records;
          this.pageInfo.total = res.total;
          this.pageInfo.pageIndex = res.current;
        });
      },

      handleBatchSet() {
        if (this.selectedRows.length > 0) {
          this.operateType = 'multiple';
          this.showDrawer = true;
        } else {
          this.$message.warning('请选择数据');
        }
      },

      /** 点击清空查询按钮 */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },

      /** 点击查询按钮 */
      handleSearchConfirm() {
        this.pageInfo.pageIndex = 1;
        this.searchTableList();
      },
      onAddDrawerClose(done) {
        done();
      },
      /** 分页 change 事件监听器 */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      /** 点击抽屉取消按钮 callback */
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            done();
            drawerDone();
          },
        });
      },
      /** 分页 size  change  事件监听器 */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      /** 获取勾选id */
      selectionChange(selection) {
        this.selectedRows = [...selection];
      },
    },
  };
</script>

<style lang="scss" scoped></style>
